import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
@Component({
  selector: 'gtd-ui-field-earning-status',
  templateUrl: './earning-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EarningStatusComponent {
  @Input() status: string;
  @Input() customClass = '';
  public statusMap = {
    draft: $localize`:@@common.draft:Draft`,
    applied: $localize`:@@common.applied:Applied`,
    paid: $localize`:@@common.paid:Paid`,
    unknown: $localize`:@@common.unknown:Unknown`,
    archived: $localize`:@@common.archived:Archived`,
  };
}
